<app-grouped-datatable
  class="campaign-details-kpi-goals-table"
  [style.display]="groupedMode() ? null : 'none'"
  [groups]="groupedMode() ? groupedRowData() : []"
  [totalParentCount]="groupedMode() ? groupedRowData().length : 0"
  [parentColumns]="groupedParentColumns()"
  [childColumns]="groupedChildColumns()"
  [customParentColumnDef]="groupedParentCustomColumns()"
  [customChildColumnDef]="groupedChildCustomColumns()"
  [configurationInput]="groupedConfiguration()"
  [isInitialDataLoaded]="!loading()"
  [loadingData]="loading()"
  [loaderConfig]="groupedSkeletonLoaderConfig"
  [currentTab]="currentTab"
  (childRowClick)="onGroupedChildRowClicked($event.child)"
/>

<app-datatable
  class="campaign-details-kpi-goals-table"
  [style.display]="groupedMode() ? 'none' : null"
  [columns]="columns"
  [configurationInput]="configuration()"
  [customColumnDef]="customColumns()"
  [loaderConfig]="skeletonLoaderConfig"
  [isInitialDataLoaded]="!loading()"
  [loadingData]="loading()"
  [rowData]="groupedMode() ? [] : rowData()"
  [total]="groupedMode() ? 0 : rowData().length"
  (rowClick)="rowClicked.emit($event.row)"
/>

<ng-template #statusColumn let-row="row">
  <app-status-badge [colorScheme]="row.rowStatusColorScheme" [status]="row.kpiGoalStatus" />
</ng-template>

<ng-template #deliverableGroupColumn let-row="row">
  <ng-container *ngTemplateOutlet="deliverableGroupColumnContent; context: { rowValue: row }" />
</ng-template>

<ng-template #deliverableGroupColumnContent let-rowValue="rowValue">
  <div class="flex items-center gap-2 px-2 py-0.5">
    <app-social-badge
      backgroundColor="transparent"
      [type]="rowValue.platformFeature"
      [size]="16"
      [iconSize]="16"
      [iconHasPlatformColor]="true"
    />
    <span
      class="line-clamp-1 text-ellipsis"
      matTooltip
      matTooltipPosition="above"
      [appTextClampTooltip]="rowValue.ctaTemplateName"
    >
      {{ rowValue.ctaTemplateName }}
    </span>
  </div>
</ng-template>

<ng-template #groupedDeliverableGroupColumn let-row="row">
  <button
    type="button"
    class="flex items-center gap-2 rounded-full px-2 py-0.5"
    [class.hover:bg-shikenso-pink-base-12]="campaignExportConfig().allowDeliverableGroupClick"
    [disabled]="!campaignExportConfig().allowDeliverableGroupClick"
    (click)="onGroupedParentRowClicked($event, row)"
  >
    <app-social-badge
      backgroundColor="transparent"
      [type]="row.platformFeature"
      [size]="16"
      [iconSize]="16"
      [iconHasPlatformColor]="true"
    />
    <span
      class="line-clamp-1 text-ellipsis"
      matTooltip
      matTooltipPosition="above"
      [appTextClampTooltip]="row.ctaTemplateName"
    >
      {{ row.ctaTemplateName }}
    </span>
  </button>
</ng-template>

<ng-template #kpiColumn let-row="row">
  <span class="line-clamp-1 text-ellipsis" matTooltip matTooltipPosition="above" [appTextClampTooltip]="row.kpiLabel">
    {{ row.kpiLabel }}
  </span>
</ng-template>

<ng-template #groupedKpiColumn let-row="row">
  <span
    class="w-[220px] shrink-0 truncate"
    matTooltip
    matTooltipPosition="above"
    [appTextClampTooltip]="row.sourceRow.kpiLabel"
  >
    {{ row.sourceRow.kpiLabel }}
  </span>
</ng-template>

<ng-template #groupedKpiValuesColumn let-row="row">
  <span class="tabular-nums">
    {{ row.sourceRow.currentValue !== null ? (row.sourceRow.currentValue | numberSuffix) : '-' }} /
    {{ row.sourceRow.targetValue | numberSuffix }}
  </span>
</ng-template>

<ng-template #groupedChildStatusColumn let-row="row">
  <app-status-badge [colorScheme]="row.rowStatusColorScheme" [status]="row.kpiGoalStatus" />
</ng-template>

<ng-template #groupedChildIndicatorColumn>
  <div class="flex items-center justify-center">
    <app-icon src="/icons/corner-down-right.svg" alt="KPI" [size]="14" />
  </div>
</ng-template>

<ng-template #creatorColumn let-row="row">
  <div class="flex min-w-0 items-center gap-2">
    <app-icon-badge
      backgroundColor="var(--shikenso-base-white)"
      fallbackBackgroundColor="var(--shikenso-gray-base)"
      [borderRadius]="100"
      [content]="row.creatorIcon"
      [fallbackText]="row.creatorName"
      [fontSize]="12"
      [iconSize]="24"
      [size]="24"
    />
    <span
      class="line-clamp-1 text-ellipsis"
      matTooltip
      matTooltipPosition="above"
      [appTextClampTooltip]="row.creatorName"
    >
      {{ row.creatorName }}
    </span>
  </div>
</ng-template>

<ng-template #currentColumn let-row="row">
  <span>{{ row.currentValue !== null ? (row.currentValue | numberSuffix) : '-' }}</span>
</ng-template>

<ng-template #targetColumn let-row="row">
  <span>{{ row.targetValue !== null ? (row.targetValue | numberSuffix) : '-' }}</span>
</ng-template>

<ng-template #kpiCountColumn let-row="row">
  <span>{{ row.kpiCount }}</span>
</ng-template>

<ng-template #dateColumn let-row="row">
  <div class="flex items-center gap-2">
    <app-icon src="/icons/calendar-event.svg" alt="Calendar" [size]="16" />
    <span>{{ row.dateLabel || '-' }}</span>
  </div>
</ng-template>
